import { Controller } from "@hotwired/stimulus"

// Weekday rows in schedule settings: «Рабочий день» switches the times on and
// off, «Как в понедельник» copies Monday to Tuesday–Friday.
export default class extends Controller {
  static targets = ["row", "status"]
  static values = { copied: String }

  connect() {
    this.rowTargets.forEach((row) => this.sync(row))
  }

  toggle(event) {
    const row = event.target.closest("[data-working-hours-target='row']")
    if (row) this.sync(row)
  }

  sync(row) {
    const enabled = row.querySelector("[data-working-hours-role='enabled']")
    const inputs = row.querySelectorAll("input[type='time']")
    inputs.forEach((input) => {
      input.disabled = enabled ? !enabled.checked : false
    })
  }

  copyWeekdays() {
    const monday = this.rowTargets.find((row) => row.dataset.weekday === "1")
    if (!monday) return
    const [start, end] = monday.querySelectorAll("input[type='time']")
    const mondayOn = monday.querySelector("[data-working-hours-role='enabled']")?.checked
    this.rowTargets
      .filter((row) => ["2", "3", "4", "5"].includes(row.dataset.weekday))
      .forEach((row) => {
        const enabled = row.querySelector("[data-working-hours-role='enabled']")
        const [rowStart, rowEnd] = row.querySelectorAll("input[type='time']")
        if (enabled) enabled.checked = Boolean(mondayOn)
        if (rowStart && start) rowStart.value = start.value
        if (rowEnd && end) rowEnd.value = end.value
        this.sync(row)
      })
    if (this.hasStatusTarget) this.statusTarget.textContent = this.copiedValue
  }
}
